module.exports = __webpack_public_path__ + "static/pic07-46eaf9ed3abb9182c52436d8603ce7e3.png";